package com.wintermar.inspection.feature.presentation.inspection.answer

actual fun setupContent(onLoad: (isMonitorScreen: Boolean, fillWidth: Float) -> Unit) {
    onLoad(
        true,
        0.5f
    )
}
